// extracted by mini-css-extract-plugin
export default {"container":"Highlight_container__z2UiA","txt":"Highlight_txt__uILYD"};